








import { Component, Mixins, Prop } from "vue-property-decorator";
import { IFreeInputableWrappedObject } from "../objects/IFreeInputableWrappedObject";
import FreeInputtableObjectMenu from "./FreeInputtableObjectMenu.vue";

@Component({
  components: {
    FreeInputtableObjectMenu,
  }
})
export default class ExpressionObjectMenu extends Mixins() {
  @Prop()
  source: IFreeInputableWrappedObject;

  @Prop()
  isInputMethodSelectable: boolean;

  get unselectedButtonConfiguration(): { class: string, label: string, description: string } {
    return {
      class: "expression-object-menu-deselected",
      label: "入力不可",
      description: "入力方法を入力不可に変更し計算結果を表示します。",
    };
  }
}
